import React, { useEffect, useState } from "react";
import { addMenu } from "../Services/MenuApi";
// import { useToken } from "../Auth/useToken";
import { Link } from "react-router-dom";
import { getCategories } from "../Services/CategrieApi";
import swal from "sweetalert";
import Repeater from "./../Components/Repeater";
import { useUser } from "../Auth/useUser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GifLoader from "../Components/loader";
import { useOrganisations } from "../Auth/useOrganisations";
import { getOrganisationById } from "../Services/OrganizationApi";
import { useTranslation } from "react-i18next";

function MenuFrom() {
  // const [token, setToken] = useToken();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [titre, setTitre] = useState({
    fr: "",
    en: "",
    ar: "",
  });
  const [description, setDescription] = useState({
    fr: "",
    en: "",
    ar: "",
  });
  const [ordre, setOrdre] = useState(1);
  const [image, setImage] = useState([]);
  const [info, setInfo] = useState([]);
  const [reference, setReference] = useState("");
  const [codeErp, setCodeErp] = useState("");

  const [readyToServe, setReadyToServe] = useState(false);

  const [categorie, setCategorie] = useState(null);
  const [selectedCategorie, setSelectedCategorie] = useState(
    "642c156479c34ac820cd6e24",
  );
  const [prix, setPrix] = useState("");
  const [prixHT, setPrixHT] = useState("");
  const [tauxTVA, setTauxTVA] = useState("19"); // Default 19%

  // Unit of Measure
  const [unite, setUnite] = useState("pcs");
  const [prixQuantite, setPrixQuantite] = useState(""); // e.g. 100 → price is for 100g

  const isWeightOrVolume = (ua) => ua !== "pcs";

  // Function to calculate VAT percentage (e.g., 19% → 0.19)
  const getTauxMultiplier = (taux) => {
    const tauxNum = parseFloat(taux) || 0;
    return tauxNum / 100;
  };

  // Function to validate and format number
  const formatNumber = (value) => {
    if (value === "") return "";
    const num = parseFloat(value);
    return isNaN(num) ? "" : num.toFixed(3); // 3 decimal places
  };

  // Handle prix change
  const handlePrixChange = (value) => {
    const formattedValue = value.replace(",", "."); // Allow comma as decimal separator
    setPrix(formattedValue);

    if (formattedValue && tauxTVA) {
      const taux = getTauxMultiplier(tauxTVA);
      const prixNum = parseFloat(formattedValue);
      if (!isNaN(prixNum)) {
        const ht = prixNum / (1 + taux);
        setPrixHT(formatNumber(ht));
      }
    } else {
      setPrixHT("");
    }
  };

  // Handle prixHT change
  const handlePrixHTChange = (value) => {
    const formattedValue = value.replace(",", ".");
    setPrixHT(formattedValue);

    if (formattedValue && tauxTVA) {
      const taux = getTauxMultiplier(tauxTVA);
      const htNum = parseFloat(formattedValue);
      if (!isNaN(htNum)) {
        const ttc = htNum * (1 + taux);
        setPrix(formatNumber(ttc));
      }
    } else {
      setPrix("");
    }
  };

  // Handle TVA rate change
  const handleTVAChange = (value) => {
    const formattedValue = value.replace(",", ".");
    setTauxTVA(formattedValue);

    // Recalculate based on which field has value
    if (prix && !prixHT) {
      // If prix has value, calculate HT
      const taux = getTauxMultiplier(formattedValue);
      const prixNum = parseFloat(prix);
      if (!isNaN(prixNum) && taux !== 0) {
        const ht = prixNum / (1 + taux);
        setPrixHT(formatNumber(ht));
      }
    } else if (prixHT && !prix) {
      // If HT has value, calculate TTC
      const taux = getTauxMultiplier(formattedValue);
      const htNum = parseFloat(prixHT);
      if (!isNaN(htNum)) {
        const ttc = htNum * (1 + taux);
        setPrix(formatNumber(ttc));
      }
    } else if (prix && prixHT) {
      // If both have values, keep them and just update TVA
      // Optionally, you can recalc to ensure consistency
      const taux = getTauxMultiplier(formattedValue);
      const prixNum = parseFloat(prix);
      const htNum = parseFloat(prixHT);

      // Check if they match the TVA rate
      const expectedTTC = htNum * (1 + taux);
      if (Math.abs(prixNum - expectedTTC) > 0.001) {
        // They don't match, recalc TTC from HT
        setPrix(formatNumber(expectedTTC));
      }
    }
  };

  // Load initial data if editing
  useEffect(() => {
    // If you're loading product data, set initial values here
    // Example:
    // if (productData) {
    //   setPrix(productData.prix_ttc?.toString() || '');
    //   setPrixHT(productData.prix_ht?.toString() || '');
    //   setTauxTVA(productData.tva?.toString() || '19');
    // }
  }, []);
  const user = useUser();
  const [infoUser] = useState(user.result);
  const [loading, setLoading] = useState(true);
  const [org, setOrg] = useState();

  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();

  const promptForDelete = () => {
    swal({
      title: "Pouf ! Votre article a été ajouté avec succès !",
      icon: "success",
    }).then(function () {
      window.location = "/menus";
    });
  };
  useEffect(() => {
    getCategories(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        alert("error");
      } else {
        console.log(res.data.data);
        setCategorie(res.data.data);
      }
    });
    getOrganisationById(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        alert("error");
      } else {
        setOrg(res.data.data);
      }
    });
  }, []);
  const onSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!titre.fr || !selectedCategorie) {
      toast.error("S'il-vous-plaît remplissez tous les champs requis!");
      return false;
    }

    // Validate price
    const regex = /^\d+(\.\d{1,3})?$/;
    const isPriceValid = regex.test(prix);

    try {
      const response = await addMenu(
        titre,
        description,
        info,
        image,
        selectedCategorie,
        org.type === "Events" ? 0 : prix,
        true,
        ordre,
        reference,
        prixHT,
        tauxTVA,
        usedOrganisations,
        unite,
        readyToServe,
        isWeightOrVolume(unite) ? parseFloat(prixQuantite) || 1 : 1,
      );

      const success = response.data.success;
      if (success === "0") {
        // Check for duplicate reference error
        if (
          response.data.message &&
          response.data.message.includes("référence")
        ) {
          toast.error(
            "Cette référence existe déjà. Veuillez utiliser une référence unique.",
          );
        } else {
          toast.error("Une erreur est survenue lors de l'ajout du menu.");
        }
      } else {
        promptForDelete();
      }
    } catch (error) {
      console.error("Error adding menu:", error);
      toast.error("Erreur lors de l'ajout du menu. Veuillez réessayer.");
    }

    return false;
  };
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  return (
    <section className="content">
      <GifLoader loading={loading} />
      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              <form onSubmit={onSubmit}>
                <div className="form-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Référence")}
                        </label>
                        <input
                          value={reference}
                          onChange={(e) => setReference(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="REF-001"
                        />
                      </div>
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Code ERP")}
                        </label>
                        <input
                          value={codeErp}
                          onChange={(e) => setCodeErp(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="Code ..."
                        />
                      </div>
                      <div className="form-group">
                        <label className="switch-row">
                          <span> {t("Prêt à servir")}</span>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={readyToServe}
                              onChange={(e) =>
                                setReadyToServe(e.target.checked)
                              }
                            />
                            <span className="slider" />
                          </label>
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Titre")}
                        </label>
                        <input
                          value={titre.fr}
                          onChange={(e) =>
                            setTitre({ ...titre, fr: e.target.value })
                          }
                          type="text"
                          className="form-control"
                          placeholder="Titre (français)"
                        />
                        <input
                          value={titre.en}
                          onChange={(e) =>
                            setTitre({ ...titre, en: e.target.value })
                          }
                          type="text"
                          className="form-control"
                          placeholder="Titre (English)"
                        />
                        <input
                          value={titre.ar}
                          onChange={(e) =>
                            setTitre({ ...titre, ar: e.target.value })
                          }
                          type="text"
                          className="form-control"
                          placeholder="العنوان (العربية)"
                        />
                      </div>

                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Catégorie")}
                        </label>
                        <select
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(e.target.value)}
                          className="form-control"
                          data-placeholder="Choose a Category"
                          tabindex="1"
                        >
                          <option value={null}></option>
                          {categorie &&
                            categorie.map((value, index) => (
                              <option value={value._id} key={index}>
                                {value.libelle.fr}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Description")}
                        </label>
                        <textarea
                          value={description.fr}
                          onChange={(e) =>
                            setDescription({
                              ...description,
                              fr: e.target.value,
                            })
                          }
                          type="text"
                          className="form-control"
                          placeholder="Description (français)"
                        ></textarea>
                        <textarea
                          value={description.en}
                          onChange={(e) =>
                            setDescription({
                              ...description,
                              en: e.target.value,
                            })
                          }
                          type="text"
                          className="form-control"
                          placeholder="Description (anglais)"
                        ></textarea>
                        <textarea
                          value={description.ar}
                          onChange={(e) =>
                            setDescription({
                              ...description,
                              ar: e.target.value,
                            })
                          }
                          type="text"
                          className="form-control"
                          placeholder="Description (arabe)"
                        ></textarea>
                      </div>
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">{t("Unité de mesure")}</h5>
                          <div className="form-group mb-0">
                            <label className="font-weight-700 font-size-16">
                              {t("Unité d'achat / vente")}
                            </label>
                            <select
                              value={unite}
                              onChange={(e) => setUnite(e.target.value)}
                              className="form-control"
                            >
                              <option value="pcs">Pièce (pcs)</option>
                              <option value="kg">Kilogramme (kg)</option>
                              <option value="L">Litre (L)</option>
                              <option value="m²">Mètre carré (m²)</option>
                            </select>
                            <small className="form-text text-muted">
                              {t(
                                "Unité utilisée lors des achats et à l'affichage",
                              )}
                            </small>
                          </div>
                        </div>
                      </div>

                      <div className="container-fluid">
                        <div className="row">
                          {/* Price Fields */}
                          <div className="col-md-12">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title">
                                  {t("Prix et Taxes")}
                                </h5>

                                {/* Prix Quantité — only for weight/volume units */}
                                {isWeightOrVolume(unite) && (
                                  <div className="form-group">
                                    <label className="font-weight-700 font-size-16">
                                      {t("Quantité de référence")}
                                    </label>
                                    <div className="input-group">
                                      <input
                                        value={prixQuantite}
                                        onChange={(e) =>
                                          setPrixQuantite(e.target.value)
                                        }
                                        type="number"
                                        className="form-control mt-0"
                                        placeholder="100"
                                      />
                                      <div className="input-group-append">
                                        <span className="input-group-text">
                                          {unite}
                                        </span>
                                      </div>
                                    </div>
                                    <small className="form-text text-muted">
                                      {t(
                                        "Le prix ci-dessous correspond à cette quantité. Ex : 100g = 2 DT",
                                      )}
                                    </small>
                                  </div>
                                )}

                                {/* TTC Price */}
                                <div className="form-group">
                                  <label className="font-weight-700 font-size-16">
                                    {isWeightOrVolume(unite) && prixQuantite
                                      ? `${t("Prix TTC pour")} ${prixQuantite} ${unite}`
                                      : t("Prix TTC (Toutes Taxes Comprises)")}
                                  </label>
                                  <div className="input-group">
                                    <input
                                      value={prix}
                                      onChange={(e) =>
                                        handlePrixChange(e.target.value)
                                      }
                                      type="text"
                                      className="form-control mt-0"
                                      placeholder="2.700"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        DT
                                      </span>
                                    </div>
                                  </div>
                                  <small className="form-text text-muted">
                                    {t("Prix final incluant la TVA")}
                                  </small>
                                </div>

                                {/* VAT Rate */}
                                <div className="form-group">
                                  <label className="font-weight-700 font-size-16">
                                    {t("Taux TVA")}
                                  </label>
                                  <div className="input-group">
                                    <input
                                      value={tauxTVA}
                                      onChange={(e) =>
                                        handleTVAChange(e.target.value)
                                      }
                                      type="text"
                                      className="form-control mt-0"
                                      placeholder="19"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        %
                                      </span>
                                    </div>
                                  </div>
                                  <small className="form-text text-muted">
                                    {t(
                                      "Taux de TVA applicable (ex: 19%, 7%, 0%)",
                                    )}
                                  </small>
                                </div>

                                {/* HT Price */}
                                <div className="form-group">
                                  <label className="font-weight-700 font-size-16">
                                    {t("Prix HT (Hors Taxes)")}
                                  </label>
                                  <div className="input-group">
                                    <input
                                      value={prixHT}
                                      onChange={(e) =>
                                        handlePrixHTChange(e.target.value)
                                      }
                                      type="text"
                                      className="form-control mt-0"
                                      placeholder="2.269"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        DT
                                      </span>
                                    </div>
                                  </div>
                                  <small className="form-text text-muted">
                                    {t("Prix hors taxes")}
                                  </small>
                                </div>

                                {/* Summary */}
                                {prix && prixHT && tauxTVA && (
                                  <div className="alert alert-info mt-3">
                                    <h6>{t("Résumé")}</h6>
                                    {isWeightOrVolume(unite) &&
                                      prixQuantite && (
                                        <p className="mb-1 font-weight-bold text-primary">
                                          {parseFloat(prix).toFixed(3)} DT{" "}
                                          {t("pour")} {prixQuantite} {unite} (
                                          {t("soit")}{" "}
                                          {(
                                            parseFloat(prix) /
                                            parseFloat(prixQuantite)
                                          ).toFixed(4)}{" "}
                                          DT/{unite})
                                        </p>
                                      )}
                                    <p className="mb-1">
                                      {t("Prix HT")}:{" "}
                                      <strong>
                                        {parseFloat(prixHT).toFixed(3)} DT
                                      </strong>
                                    </p>
                                    <p className="mb-1">
                                      {t("TVA")} ({tauxTVA}%):{" "}
                                      <strong>
                                        {(
                                          parseFloat(prix) - parseFloat(prixHT)
                                        ).toFixed(3)}{" "}
                                        DT
                                      </strong>
                                    </p>
                                    <p className="mb-0">
                                      {t("Total TTC")}:{" "}
                                      <strong>
                                        {parseFloat(prix).toFixed(3)} DT
                                      </strong>
                                    </p>
                                  </div>
                                )}

                                {/* Submit Button */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <h4 className="box-title mt-20">{t("Uploaded Image")}</h4>
                      <div className="product-img text-left">
                        <img
                          src={
                            image.length
                              ? URL.createObjectURL(image[0])
                              : "images/product/no-image.png"
                          }
                          alt=""
                          className="mb-15"
                        />
                        <p>{t("Upload Anonther Image")}</p>
                        <div className="btn btn-info mb-20 choose-file">
                          <input
                            onChange={(e) => setImage(e.currentTarget.files)}
                            type="file"
                            name="logo"
                            multiple
                            className="upload"
                          />
                        </div>
                        {image ? (
                          <div className="pic-actions">
                            <button className="btn btn-success left-button">
                              {t("Edit")}
                            </button>
                            <button className="btn btn-danger">
                              {t("Delete")}
                            </button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <label className="font-weight-700 font-size-16">
                    Informations générales
                  </label>
                  <div
                    className="row mt-10"
                    style={{ flexWrap: "nowrap", display: "flex" }}
                  >
                    <Repeater onChange={setInfo} />
                  </div> */}

                  {/* Unit of Measure — all org types */}
                  <div className="row mt-10">
                    <div className="col-md-6"></div>
                  </div>
                </div>
                <div className="form-actions mt-10">
                  <Link to="/">
                    <button type="button" className="btn btn-primary">
                      Annuler
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-danger left-button">
                    {" "}
                    <i className="fa fa-check"></i> {t("Ajouter")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default MenuFrom;
